import React, { useState, useEffect } from "react";
import Layout from "../layout/Layout";
import Line from "../assets/img/Line.png";

import { PiFoldersFill } from "react-icons/pi";
import { MdOutlineFileDownload } from "react-icons/md";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { useParams, useNavigate } from "react-router-dom";

import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Typography,
} from "@material-tailwind/react";

import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import useEncryption from "../useEncryption/useEncryption";

import PDF from "../../Components/assets/img/fileplaceholder.png";
import { BACKEND_BASE_URL } from "../../apiInstances/baseurl";

const UserFolderView = () => {
  const { decryptData } = useEncryption();
  const navigate = useNavigate();
  let { id } = useParams();

  const [selectedFolder, setSelectedFolder] = useState("");
  const [allFolder, setAllFolder] = useState([]);

  const [allFolderFile, setAllFolderFile] = useState([]); // all folder file

  const [folderId, setFolderId] = useState();
  const [renameNewFolder, setRenameNewFolder] = useState("");
  console.log("🚀 ~ UserFolderView ~ renameNewFolder:", renameNewFolder);

  const [fileId, setFileId] = useState("");
  // console.log(
  //   "🚀 fileId fileId fileIdfileIdfileIdfileIdfileIdfileIdfileId fileId:",
  //   fileId
  // );

  const getFolderClass = (folderName) => {
    return selectedFolder === folderName
      ? "bg-[#22345C] text-white  "
      : "bg-white text-[#666666] ";
  };

  // Get All Folder Show
  const getFolderdata = async () => {
    await axiosInstanceAuth
      .get(`/view_folder_admin_user/${id}`)
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        setAllFolder(myData?.data || []);

        for (let d of myData?.data) {
          if (d.foldername) {
            setRenameNewFolder(d.foldername);
          }
          console.log("🚀 ~ .then ~ d:", d.foldername);
        }
        console.log("view_folder_admin_user---->", myData?.data);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  useEffect(() => {
    getFolderdata();
  }, []);

  const handleCreateFolderClick = (folderName, id) => {
    setSelectedFolder(folderName);
    setFolderId(id);
    setFileId(id);
  };

  const backButtonClick = () => {
    navigate("/addUser");
  };

  // Get All Folder File Show
  const getFolderFiledata = async () => {
    await axiosInstanceAuth
      .get(`view_folder_file/${folderId}`)
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        setAllFolderFile(myData?.data || []);
        console.log("🚀 Folder File Show ", myData?.data);
        for (let d of myData?.data) {
          if (d._id) {
            setFileId(d._id);
          }
        }
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  useEffect(() => {
    getFolderFiledata(fileId);
  }, [fileId]);

  const viewFolderFile = (folderId, selectfileid) => {
    navigate(`/userfolderfileshow/${folderId}/${selectfileid}`);
  };

  //download Single file API calling
  const handleDownload = async (id) => {
    const response = await axiosInstanceAuth.post(`Download_file/${folderId}`, {
      file_id: id,
    });

    const filePath = decryptData(response?.data?.data);
    console.log("🚀 ~ handleDownload ~ filePath:", filePath);
    const generatelink = `${BACKEND_BASE_URL}${filePath?.data?.path}`;
    console.log("🚀 ~ handleDownload ~ generatelink:", generatelink);
    fetch(generatelink) // Replace with the appropriate URL
      .then((response) => {
        console.log("🚀 ~ .then ~ response:", response);
        if (response.status) {
          return response.blob();
        } else {
          throw new Error("Failed to download PDF");
        }
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filePath?.data?.name;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
  };

  // localStorage.setItem("FolderID", folderId);

  const renderTabContent = () => {
    if (allFolder.some((folder) => folder.foldername === selectedFolder)) {
      // If the selected folder is a user-created folder, show "Coming soon" message
      return (
        <div className="grid lg:grid-cols-4  grid-cols-2 gap-10 mt-5 mb-5">
          {allFolderFile?.length > 0 &&
            allFolderFile.map((i, index) => (
              <div
                key={index}
                className="justify-between items-center text-[#666666] bg-[#FFFFFF] p-5 rounded-[10px] border-gray-400 "
              >
                <div className="border-[1.5px] border-black rounded-md p-1">
                  <img src={PDF} alt="" className="w-full h-72" />
                </div>

                <div className="items-center mt-3 text-center h-8 space-y-4">
                  <p className="font-sans font-bold text-[#2B2B2B] text-[18px]">
                    File Name : {i.filename}
                  </p>
                </div>
                <div class="flex flex-wrap justify-center gap-6 pt-12">
                  {/* {console.log(i?._id)} */}
                  <div
                    class="relative "
                    href="#"
                    onClick={() => {
                      viewFolderFile(folderId, i?._id);
                    }}
                  >
                    <span class="absolute top-0 left-0 mt-1 ml-1 h-full w-full rounded-[10px] bg-black"></span>
                    <span class="fold-bold relative inline-block h-full w-full rounded-[10px] bg-[#22345C] px-3 py-2 text-base font-bold text-white transition duration-100">
                      View
                    </span>
                  </div>

                  <div
                    class="relative "
                    href="#"
                    onClick={(e) => {
                      // setGetid(i?._id);
                      e.stopPropagation(); // Prevents the row click event from being triggered
                      handleDownload(i?._id);
                    }}
                  >
                    <span class="absolute top-0 left-0 mt-1 ml-1 h-full w-full rounded-[10px] bg-black"></span>
                    <span class="fold-bold relative inline-block h-full w-full rounded-[10px] bg-[#22345C] px-3 py-2 text-base font-bold text-white transition duration-100">
                      Download
                    </span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      );
    }
  };

  const renderTab = () => {
    if (allFolder.some((folder) => folder.foldername === selectedFolder)) {
      // If the selected folder is a user-created folder
      if (allFolderFile.length > 0) {
        return (
          <div className="grid lg:grid-cols-4  grid-cols-2 gap-10 mt-5 mb-5">
            {allFolderFile?.length > 0 &&
              allFolderFile.map((i, index) => (
                <div
                  key={index}
                  className="justify-between items-center text-[#666666] bg-[#FFFFFF] p-5 rounded-[10px] border-gray-400 "
                >
                  <div className="border-[1.5px] border-black rounded-md p-1">
                    <img src={PDF} alt="" className="w-full h-72" />
                  </div>

                  <div className="items-center mt-3 text-center h-8 space-y-4">
                    <p className="font-sans font-bold text-[#2B2B2B] text-[18px]">
                      File Name : {i.filename}
                    </p>
                  </div>
                  <div class="flex flex-wrap justify-center gap-6 pt-12">
                    {/* {console.log(i?._id)} */}
                    <div
                      class="relative "
                      href="#"
                      onClick={() => {
                        viewFolderFile(folderId, i?._id);
                      }}
                    >
                      <span class="absolute top-0 left-0 mt-1 ml-1 h-full w-full rounded-[10px] bg-black"></span>
                      <span class="fold-bold relative inline-block h-full w-full rounded-[10px] bg-[#22345C] px-3 py-2 text-base font-bold text-white transition duration-100">
                        View
                      </span>
                    </div>

                    <div
                      class="relative "
                      href="#"
                      onClick={(e) => {
                        // setGetid(i?._id);
                        e.stopPropagation(); // Prevents the row click event from being triggered
                        handleDownload(i?._id);
                      }}
                    >
                      <span class="absolute top-0 left-0 mt-1 ml-1 h-full w-full rounded-[10px] bg-black"></span>
                      <span class="fold-bold relative inline-block h-full w-full rounded-[10px] bg-[#22345C] px-3 py-2 text-base font-bold text-white transition duration-100">
                        Download
                      </span>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      } else {
        return (
          <div className="text-center mt-5">
            <p className="text-4xl font-sans font-bold text-center mt-60 text-[#22345C]">
              No File available for the selected folder.
            </p>
          </div>
        );
      }
    }
  };

  const renderTabFolder = () => {
    if (allFolder.length > 0) {
      return (
        <div className="grid lg:grid-cols-4   grid-cols-2 gap-5 mt-5">
          {allFolder?.map((folder, index) => (
            <>
              <div
                key={index}
                className={`flex justify-between items-center p-5 rounded-[10px] border-gray-400 ${getFolderClass(
                  folder.foldername
                )}`}
                onClick={() => {
                  handleCreateFolderClick(folder.foldername, folder._id);
                }}
              >
                <div className="flex gap-2 items-center">
                  <PiFoldersFill size={25} />
                  <p className="font-sans font-medium">{folder.foldername}</p>
                </div>
                <Menu>
                  <MenuHandler>
                    <svg
                      width="4"
                      height="16"
                      viewBox="0 0 4 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="cursor-pointer"
                    >
                      <path
                        d="M7.03223e-06 2.0049C-0.00290308 0.916186 0.897777 0.00952867 1.99052 6.15717e-05C3.08473 -0.00867729 4.00723 0.914001 3.99996 2.00927C3.99268 3.10309 3.08618 4.00537 1.9978 4.00246C0.907962 4.00028 0.00291715 3.0958 7.03223e-06 2.0049Z"
                        fill="#565656"
                      />
                      <path
                        d="M1.99927 5.99829C3.08911 5.99829 3.99342 6.89985 3.99924 7.99293C4.00579 9.0882 3.08038 10.0116 1.98836 10.0007C0.895609 9.98976 -0.00507121 9.08092 2.14911e-05 7.99366C0.00511419 6.9013 0.910159 5.99829 1.99927 5.99756V5.99829Z"
                        fill="#565656"
                      />
                      <path
                        d="M2.15256e-05 14.0037C-0.00507117 12.9157 0.894154 12.0076 1.98836 11.9967C3.0811 11.985 4.00506 12.907 3.99997 14.0037C3.99488 15.0961 3.08983 15.9998 2.00072 15.9998C0.911614 15.9991 0.00511422 15.0953 2.15256e-05 14.0037Z"
                        fill="#565656"
                      />
                    </svg>
                  </MenuHandler>
                  <MenuList>
                    <MenuItem className="flex items-center gap-2">
                      <MdOutlineFileDownload size={22} />

                      <Typography
                        variant="small"
                        className="font-sans font-medium text-base"
                        onClick={() => handleDownloadFolder()}
                      >
                        Download
                      </Typography>
                    </MenuItem>
                  </MenuList>
                </Menu>
              </div>
            </>
          ))}
        </div>
      );
    } else {
      return (
        <div className="text-center mt-5">
          <p className="text-4xl font-sans font-bold text-center mt-60 text-[#22345C]">
            No Folder available for the selected User.
          </p>
        </div>
      );
    }
  };

  const handleDownloadFolder = async () => {
    try {
      const response = await axiosInstanceAuth.get(
        `download_folder/${folderId}`,
        {
          responseType: "blob", // Set the response type to blob for binary data
        }
      );

      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: "application/zip" });

      // Create a link element and trigger a click to download the file
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = renameNewFolder;
      link.click();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  return (
    <Layout>
      <div className="container">
        <div className="md:flex justify-between  mt-8">
          <div className="flex lg:text-[30px] text-[20px] font-semibold gap-3 justify-center items-center">
            <img src={Line} alt="" className="h-7" />
            <h1 className="text-[#22345C]">User Details</h1>
          </div>
        </div>

        <div>
          <button
            onClick={backButtonClick}
            class="bg-[#22345C] gap-1 mt-5 text-[#FFFFFF] font-sans text-lg font-bold py-1.5 px-2 rounded-[10px] inline-flex items-center"
          >
            <HiOutlineArrowNarrowLeft size={25} className="text-[#FFFFFF]" />
            <span>Back</span>
          </button>
        </div>

        {/* Folder Show Code  */}
        {/* <div>
          <div className="text-[#6F6F6F] font-medium font-sans text-xl mt-5">
            All Folder
          </div>
          <div className="grid lg:grid-cols-4   grid-cols-2 gap-5 mt-5">
            {allFolder?.map((folder, index) => (
              <>
                <div
                  key={index}
                  className={`flex justify-between items-center p-5 rounded-[10px] border-gray-400 ${getFolderClass(
                    folder.foldername
                  )}`}
                  onClick={() => {
                    handleCreateFolderClick(folder.foldername, folder._id);
                  }}
                >
                  <div className="flex gap-2 items-center">
                    <PiFoldersFill size={25} />
                    <p className="font-sans font-medium">{folder.foldername}</p>
                  </div>
                  <Menu>
                    <MenuHandler>
                      <svg
                        width="4"
                        height="16"
                        viewBox="0 0 4 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="cursor-pointer"
                      >
                        <path
                          d="M7.03223e-06 2.0049C-0.00290308 0.916186 0.897777 0.00952867 1.99052 6.15717e-05C3.08473 -0.00867729 4.00723 0.914001 3.99996 2.00927C3.99268 3.10309 3.08618 4.00537 1.9978 4.00246C0.907962 4.00028 0.00291715 3.0958 7.03223e-06 2.0049Z"
                          fill="#565656"
                        />
                        <path
                          d="M1.99927 5.99829C3.08911 5.99829 3.99342 6.89985 3.99924 7.99293C4.00579 9.0882 3.08038 10.0116 1.98836 10.0007C0.895609 9.98976 -0.00507121 9.08092 2.14911e-05 7.99366C0.00511419 6.9013 0.910159 5.99829 1.99927 5.99756V5.99829Z"
                          fill="#565656"
                        />
                        <path
                          d="M2.15256e-05 14.0037C-0.00507117 12.9157 0.894154 12.0076 1.98836 11.9967C3.0811 11.985 4.00506 12.907 3.99997 14.0037C3.99488 15.0961 3.08983 15.9998 2.00072 15.9998C0.911614 15.9991 0.00511422 15.0953 2.15256e-05 14.0037Z"
                          fill="#565656"
                        />
                      </svg>
                    </MenuHandler>
                    <MenuList>
                      <MenuItem className="flex items-center gap-2">
                        <MdOutlineFileDownload size={22} />

                        <Typography
                          variant="small"
                          className="font-sans font-medium text-base"
                          // onClick={() => handleDownloadFolder()}
                        >
                          Download
                        </Typography>
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </div>
              </>
            ))}
          </div>
        </div> */}

        <div>
          <div className="text-[#6F6F6F] font-medium font-sans text-xl mt-5">
            All Folder
          </div>
          <div className="">{renderTabFolder()}</div>
        </div>

        <div className="">{renderTab()}</div>
        {/* =================================  */}
      </div>
    </Layout>
  );
};

export default UserFolderView;
